<div class="sabis-datepicker">
  <div>
    @if (scLabel) {
      <label class="control-label">
        {{ scLabel }}
        <span class="sc-required sabis-datepicker__required-star"></span>
      </label>
    }
  </div>

  <mat-form-field>
    <mat-label>{{ scLabel }}</mat-label>
    <input matInput
      [matDatepicker]="picker"
      [attr.disabled]="isDisabled ? true : null"
      name="date"
      [min]="min"
      [max]="max"
      (focus)="onDatePickerFocus()"
      (blur)="onDatePickerBlur()"
      (ngModelChange)="onDatePickerChange($event)"
      [(ngModel)]="value">
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [disabled]="isDisabled" [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    @if (!scHideValidationMessage && !isValid) {
      <p class="sc-error-message">{{validationMessage}}</p>
    }
  </div>
